const state = {
  loadingLobby: true,
  showLobby: true,

  spaceId: null,
  spaceData: null,
  isLeaving: false,
  isInvalid: false,
  invalidReason: null,

  enterAfterAuth: false,
  rejoinAfterAuth: false,
};

const getters = {
  loadingLobby: (state) => state.loadingLobby,
  showLobby: (state) => state.showLobby,
  onLobby: (state, getters, rootState, rootGetters) => getters.showLobby && rootGetters['routing/routeName'] === 'area',

  spaceId: (state) => state.spaceId,
  spaceData: (state) => state.spaceData,
  spaceName: (state,getters) => getters.spaceData?.title || '',

  isLeaving: (state) => state.isLeaving,
  isInvalid: (state) => state.isInvalid,
  invalidReason: (state) => state.invalidReason,
};

const mutations = {
  LOADING_LOBBY: (state, value) => state.loadingLobby = value,
  SHOW_LOBBY: (state, value) => state.showLobby = value,

  SPACE_ID: (state, value) => state.spaceId = value,
  SPACE_DATA: (state, value) => state.spaceData = value,
  LEAVING: (state, value) => state.isLeaving = value,
  INVALID: (state, value) => state.isInvalid = value,
  INVALID_REASON: (state, value) => state.invalidReason = value,
};

const actions = {
  loadingLobby: ({commit}) => commit('LOADING_LOBBY', true),
  loadedLobby: ({commit}) => commit('LOADING_LOBBY', false),
  showLobby: ({commit}) => commit('SHOW_LOBBY', true),
  hideLobby: ({commit}) => commit('SHOW_LOBBY', false),
  async handleAccessLobby({commit, dispatch}, spaceId) { //check link access on page load
    if(!spaceId) {
      commit('INVALID', true)
      commit('INVALID_REASON', 'no_token_provided')
      return
    }
    commit('SPACE_ID', spaceId)
    let res = await dispatch('api/nav/accessGuestSpace', spaceId, {root: true})
    let data = res?.success
    if(data) {
      commit('guest/USER_ID', data.userId, {root: true})
      commit('SPACE_ID', data.locationId)
      commit('SPACE_DATA', data.locationPartialDetails)
      commit('INVALID', false)

      commit('current_user/EXTERNAL_GUEST', data.isExternalGuest, {root: true})
      if(data.isExternalGuest) {
        //direct entry via url params (hidden feature)
        let nameParam = await dispatch('routing/getQueryValue', 'n', {root: true})
        if(nameParam) {
          let res = await dispatch('handleEnterOpenSpaceAsGuest', nameParam)
          if(res?.success) {
            commit('SHOW_LOBBY', false)
            return
          }
        }
        commit('SHOW_LOBBY', true)
      }
      else commit('SHOW_LOBBY', false)
    } else {
      commit('INVALID', true)
      if (res.error) {
        commit('current_user/EXTERNAL_GUEST', res.error.isExternalGuest, {root: true})
        if (res.error.status == 404) commit('INVALID_REASON', 'not_found')
        else commit('INVALID_REASON', res.error.code)
      }
    }

    return res
  },
  async handleEnterOpenSpaceAsGuest({getters, commit, dispatch}, username) {
    commit('guest/USERNAME', username, {root: true})
    //guest create login
    await dispatch('guest/createGuestAccount', [username, getters.spaceId], {root: true})

    let res = await dispatch('enterAreaHandlerAsGuest', getters.spaceId, {root: true})

    dispatch('analytics/enterSpaceLobbyAsGuest', [username, getters.spaceId, res], {root: true})

    return res
  },
  async updateData({commit, dispatch}, data) {
    if(!data) return console.log('NO DATA')
    commit('AREA_ID', data.areaId)
    commit('ROOM_ID', data.spaceId)
    commit('WAITING', data.onHold)
    commit('PASSWORD_REQUIRED', data.passwordRequired)

    //if onHold is false, enter room
    await dispatch('enterRoomOnUpdate')
    return
  },
  async returnToSpaceLobby({ rootGetters, getters, commit, dispatch}) {
    await dispatch('handleAccessLobby', getters.spaceId || rootGetters['routing/getParamValue']('areaId'))
    dispatch('showLobby')
    commit('LEAVING', true)
    dispatch('api/auth/logoutAPI', null, {root: true})
  },

  refreshLobby({commit}) { //reset all to original as if refreshing page
    commit('LEAVING', false)
    commit('INVALID', false)
    commit('INVALID_REASON', null)
    commit('guest/ENTER_AFTER_AUTH', false, {root: true})
    commit('guest/REJOIN_AFTER_AUTH', false, {root: true})
  },

  async enterSpaceAsExistingGuest({rootGetters, getters, dispatch}, type) { //type for redirect/callback
    let guest = rootGetters['guest/guestStorageData']
    if(guest?.userId && guest?.oneTimeSignInToken) {
      await dispatch('api/auth/loginAsGuest',[guest.userId, guest.oneTimeSignInToken, type], {root: true})
      await dispatch('enterAreaHandlerAsGuest', getters.spaceId, {root: true})
      dispatch('analytics/enterSpaceAsExistingGuest', [guest.userId, guest.oneTimeSignInToken, type], {root: true})
    }
    return
  },

  async handleAddOpenSpaceToCollection({getters, rootGetters, dispatch}) {
    let res = await dispatch('api/nav/addOpenSpaceToCollection', getters.spaceId || rootGetters.getCurrentAreaId, {root: true})
    let data = res?.success
    if(data) {
      dispatch('popups/show/success/custom', 'Space added to your collection', {root: true})
      await dispatch('enterAreaHandler', getters.spaceId || rootGetters.getCurrentAreaId, {root: true})
    } else {
      if (res.error) {
        dispatch('popups/show/error/custom', 'adding this Space to your Collection', {root: true})
      }
    }

    return data
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
